import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Subject } from 'rxjs';
import PropTypes from 'prop-types';
import * as Actions from '../store/seller/presets/seller.presets.actions';

import { EditPresetModal } from '../components/modals/edit-preset-modal';
import { ShippingPresetPropType } from '../prop-types/shipping-preset';

export const editOrCreatePresetSubject = new Subject();

export const EditPresetModalContainer = (props) => {
  const { onClose } = props;
  const dispatch = useDispatch();

  const savePreset = useCallback(
    (presetId, preset) => {
      dispatch(Actions.createOrSavePreset(presetId, preset));
    },
    [dispatch],
  );

  useEffect(() => {
    // This is super basic now just to replicate previous interaction.
    // can be updated to include an error message, which the previous functionality did not.
    const subscription = editOrCreatePresetSubject.subscribe((success) => {
      if (success) {
        onClose();
      }
    });
    return () => subscription.unsubscribe();
  }, [onClose]);

  return <EditPresetModal {...props} savePreset={savePreset} />;
};

EditPresetModalContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  preset: ShippingPresetPropType.isRequired,
};
